import { defineMessages } from "react-intl";

const messages = defineMessages({
  finishButtonTitle: {
    id: "map.tool.leadFinder.addRecords.finishButtonTitle",
    defaultMessage: "Add as {entityName}",
    description: "Finish button title",
  },
  title: {
    id: "map.tool.leadFinder.addRecords.title",
    defaultMessage: "Add {count} {count, plural, one {lead} other {leads}}",
    description: "Lead Finder - Add to Records modal title",
  },
});

export default messages;
